import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "absolute inset-0 pointer-events-none overflow-hidden" }
const _hoisted_2 = {
  key: 0,
  class: "absolute inset-0 stars-bg opacity-30"
}
const _hoisted_3 = { class: "max-w-6xl mx-auto relative z-10" }
const _hoisted_4 = { class: "text-center mb-12" }
const _hoisted_5 = { class: "text-3xl md:text-4xl font-bold mb-4" }
const _hoisted_6 = { class: "galaxy-text-gradient" }
const _hoisted_7 = { class: "grid md:grid-cols-3 gap-8" }
const _hoisted_8 = { class: "galaxy-card overflow-hidden h-full flex flex-col" }
const _hoisted_9 = {
  key: 0,
  class: "absolute inset-0 stars-bg opacity-40"
}
const _hoisted_10 = { class: "relative z-10" }
const _hoisted_11 = { class: "text-4xl mb-3" }
const _hoisted_12 = { class: "text-xl font-bold" }
const _hoisted_13 = { class: "text-white/80 text-sm mt-1" }
const _hoisted_14 = { class: "p-6 flex-1" }

import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'CoursesSection',
  props: {
    isDark: { type: Boolean }
  },
  setup(__props: any) {



const { t } = useI18n()

const levels = [
  { key: 'little_explorers', icon: '🚀', bgClass: 'bg-gradient-to-br from-nebula-cyan/80 to-nebula-blue/80' },
  { key: 'young_innovators', icon: '💡', bgClass: 'bg-gradient-to-br from-nebula-purple/80 to-galaxy-600/80' },
  { key: 'teen_creators', icon: '🎯', bgClass: 'bg-gradient-to-br from-nebula-pink/80 to-secondary-500/80' }
]

const subjects = [
  { key: 'robotics', icon: 'smart_toy' },
  { key: 'programming', icon: 'code' },
  { key: 'ai', icon: 'psychology' },
  { key: 'animation', icon: 'movie' }
]

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!

  return (_openBlock(), _createElementBlock("section", {
    id: "courses",
    class: _normalizeClass(["section-padding relative overflow-hidden transition-colors duration-500", __props.isDark ? 'galaxy-section-dark' : 'galaxy-section-light'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (__props.isDark)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["absolute top-1/4 left-0 w-72 h-72 rounded-full blur-3xl opacity-10", __props.isDark ? 'bg-nebula-blue' : 'bg-primary-200'])
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["absolute bottom-1/4 right-0 w-72 h-72 rounded-full blur-3xl opacity-10", __props.isDark ? 'bg-nebula-pink' : 'bg-secondary-200'])
      }, null, 2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h2", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('courses.sectionTitle')), 1)
        ]),
        _createElementVNode("p", {
          class: _normalizeClass(["text-lg", __props.isDark ? 'text-galaxy-200' : 'text-gray-600'])
        }, _toDisplayString(_unref(t)('courses.subtitle')), 3)
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(levels, (level) => {
          return _createElementVNode("div", {
            key: level.key,
            class: "group"
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", {
                class: _normalizeClass([level.bgClass, "p-6 text-white text-center relative overflow-hidden"])
              }, [
                (__props.isDark)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(level.icon), 1),
                  _createElementVNode("h3", _hoisted_12, _toDisplayString(_unref(t)(`courses.levels.${level.key}.name`)), 1),
                  _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(t)(`courses.levels.${level.key}.ages`)), 1)
                ])
              ], 2),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("p", {
                  class: _normalizeClass(["text-center mb-4", __props.isDark ? 'text-galaxy-200' : 'text-gray-600'])
                }, _toDisplayString(_unref(t)(`courses.levels.${level.key}.description`)), 3),
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(subjects, (subject) => {
                  return _createVNode(_component_q_expansion_item, {
                    key: subject.key,
                    label: _unref(t)(`courses.subjects.${subject.key}.title`),
                    icon: subject.icon,
                    "header-class": __props.isDark ? 'text-nebula-cyan font-semibold' : 'text-primary-700 font-semibold',
                    dense: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_card, {
                        flat: "",
                        class: _normalizeClass(__props.isDark ? 'bg-transparent' : '')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_card_section, {
                            class: _normalizeClass(["text-sm", __props.isDark ? 'text-galaxy-200' : 'text-gray-600'])
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)(`courses.subjects.${subject.key}.description`)), 1)
                            ]),
                            _: 2
                          }, 1032, ["class"])
                        ]),
                        _: 2
                      }, 1032, ["class"])
                    ]),
                    _: 2
                  }, 1032, ["label", "icon", "header-class"])
                }), 64))
              ])
            ])
          ])
        }), 64))
      ])
    ])
  ], 2))
}
}

})